import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;
  @Input() pageTitle: string = '';
  populations = Populations;
}
